import React from 'react';
import { PrimaryButtonProps } from '../../../types/header.types';
import PlusIcon from '../icons/plus.icon';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const PrimaryButton: React.FC<PrimaryButtonProps & { onClick?: () => void }> = ({
  text,
  className = '',
  disabled = false,
  loading = false,
}) => {
  const navigate = useNavigate();

  const location = useLocation();
  const lang = new URLSearchParams(location.search).get('lang') || 'en-us';

  const handleClick = () => {
    const url = lang === "en-us" ? '/v2/create-invoice?lang=en-us' : '/v2/create-invoice?lang=sv-se';
    navigate(url);
  };

  return (
    <button
      className={`primary-button ${className} ${disabled ? 'primary-button--disabled' : ''} ${loading ? 'primary-button--loading' : ''}`}
      onClick={handleClick}
      disabled={disabled || loading}
      type="button"
      aria-label={text}
    >
      <div className="primary-button__content">
        <div className="d-sm-block d-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={14}
          height={14}
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M7 1V13M13 7L1 7"
            stroke="white"
            strokeWidth={2}
            strokeLinecap="round"
          />
        </svg>
        </div>

        <span className="primary-button__text">
          {loading ? 'Loading...' : text}
        </span>
      </div>
    </button>
  );
};

// Specialized Create Invoice Button component
export const CreateInvoiceButton: React.FC<{
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
}> = ({ className, disabled, loading, label = '' }) => {
  return (
    <PrimaryButton
      text={label}
      icon={<PlusIcon />}
      className={className}
      disabled={disabled}
      loading={loading}
    />
  );
};

export default PrimaryButton;
